export default __webpack_public_path__ + "static/media/down-arrow.9de47c88.svg";